import styles from './RestorePass.module.css'
import ModalWindow from "../../FormTemplate/ModalWindow/ModalWindow";
import React, {useEffect, useRef, useState} from "react";
import useFormValidator, {FormValidatorInt} from "../../FormValidator/FormValidator";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {setSlider} from "../../Reducer/GlobalReducer";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
export default function RestorePass()
{
    const errorLineRef = useRef<ErrorLineItemRef>(null)

    const [isCodeRequest, setIsCodeRequest] = useState(false)
    const [canRequestCode, setCanRequestCode] = useState(false)


    const [loginError,setLoginError] = useState({
        show:false,
        text: ""
    })
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [login, setLogin] = useState("")
    const dataCapt = useRef({
        name: "pRestore",
        len:4,
        useDigit: false
    })
    const [ldrDataCapt,rsDataItemCapt,exLoadDataCapt] = useApiQuery("/auth/capt","post",dataCapt);
    const [capt,setCap]=useState("")

    const requestCodeData = useRef({
        login:"",
        capt:""
    })
    const [ldrRequestCode,rsRequestCode,exRequestCode] = useApiQuery("/auth/request/code","post",requestCodeData);


    const changePassData = useRef({
        login:"",
        capt:"",
        code:"",
        pass:""
    })
    const [ldrChangePass,rsChangePass,exChangePass] = useApiQuery("/auth/pass/restore","post",changePassData);


    const [formData,setFormData]=useState<FormValidatorInt[]>([
        {
            val:"",
            id:"login",
            errText: "Не корректный логин",
            regExp: /^[a-z0-9]+[a-z0-9-@._]+$/i,
            isCheck: true,
            valid: true
        },
        {
            val:"",
            id:"pass",
            errText: "Не корректный пароль (от 8 символов)",
            regExp: /^.{8,}$/i,
            isCheck: true,
            valid: true
        },
        {
            val:"",
            id:"code",
            errText: "Не корректный код",
            regExp: /^[0-9]{4}$/i,
            isCheck: true,
            valid: true

        },
        {
            val:"",
            id:"capt",
            errText: "Не корректный код",
            regExp: /^[a-z0-9]{4}$/i,
            isCheck: true,
            valid: true,
        },
    ])

    const [validate,validateById,getValue,setValue,getErrText] = useFormValidator(formData)
    useEffect(()=>{
        loadNewCapt()
    },[dataCapt])

    const loadNewCapt= ()=>
    {
        exLoadDataCapt().then((e)=>{
            if(e?.success)setCap(e?.payload)
        })

    }

    const valCanRequest  =  () =>{
        let can = true
        formData.map((item)=>{
            if(item?.id?.match(/login/ui) && !item?.val?.match( item?.regExp) )can = false
            if(item?.id?.match(/capt/ui) && !item?.val?.match( item?.regExp) )can = false
        })
        return can
    }

    const valCanChange = () =>{
        let can = valCanRequest()
        if(! can) return false
        formData.map((item)=>{
            if(item?.id?.match(/pass/ui) && !item?.val?.match( item?.regExp) )can = false
            if(item?.id?.match(/code/ui) && !item?.val?.match( item?.regExp) )can = false
        })
        return can

    }

    const handleRequestCode = () =>{
        requestCodeData.current = {
            capt: getValue("capt"),
            login: getValue("login")
        }
        exRequestCode().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef?.current)errorLineRef?.current?.show( `Код отправлен на почту ${e?.payload?.eMail}`, false,5000 )
                setLogin(e?.payload?.login)
                setIsCodeRequest(true)
                return

            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,4000 )
            loadNewCapt()
            setValue("capt","")
        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,4000 )
            loadNewCapt()
        })
    }


    const handlePassChange = () =>{
        changePassData.current = {
            capt: getValue("capt"),
            login: login,
            pass : getValue("pass"),
            code: getValue("code")
        }
        exChangePass().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef?.current)errorLineRef?.current?.show("Пароль сменен", false,2000 )
                setTimeout(()=>{navigate('/auth')},2000)

                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,2000 )
            loadNewCapt()
            setValue("capt","")
        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,2000 )
            loadNewCapt()
            setValue("capt","")

        })
    }

    return(
        <ModalWindow>
            <div className={styles.mainCont}>
                <div className={styles.modal}>
                    <form style={{width:"100%"}}>
                        <div className="mb-3">
                            <label htmlFor="exampleInputEmail1" className="form-label">Логин  <span className={styles.smSpan}>[ или почта ]</span></label>
                            <input type="text" className="form-control"
                                   aria-describedby="emailHelp"
                                   value={getValue("login")}
                                   onBlur={()=>validateById("login")}
                                   onChange={(e)=>{setValue("login",e.target.value); validateById("login")}}></input>
                            <div  className={["", styles.errMessage].join(' ')}>{getErrText("login")}</div>

                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleInputEmail1" className="form-label">Новый пароль</label>
                            <input type="password" className="form-control"
                                   aria-describedby="emailHelp"
                                   value={getValue("pass")}
                                   onBlur={()=>validateById("pass")}
                                   onChange={(e)=>{setValue("pass",e.target.value); validateById("pass")}}></input>
                            <div  className={["", styles.errMessage].join(' ')}>{getErrText("pass")}</div>

                        </div>
                        <div className={["mb-3 form-check px-0"].join(' ')}>
                            <div className={styles.captContainer}
                                onClick={()=>loadNewCapt()}
                            >
                                <label htmlFor="exampleInputEmail1" className="form-label">Код <span className={styles.smSpan}>[ капча ]</span></label>
                                <img className={styles.capImg} src={capt}/>
                            </div>
                            <input type="text" className="form-control"
                                   aria-describedby="emailHelp"
                                   value={getValue("capt")}
                                   onBlur={()=>validateById("capt")}
                                   onChange={(e)=>{setValue("capt",e.target.value); validateById("capt")}}
                                   onKeyDown={(e)=>{
                                       if(e.key.match(/enter/i)){}
                                   }}

                            ></input>
                            <div  className={["", styles.errMessage].join(' ')}>{getErrText("capt")}</div>
                        </div>

                        <div className={["mb-2", styles.pCont].join(' ')}>
                            <label htmlFor="exampleInputEmail1" className="form-label">Проверочный код <span className={styles.smSpan}>[ из почты ]</span></label>
                            <input type="text" className="form-control"
                                   aria-describedby="emailHelp"
                                   value={getValue("code")}
                                   disabled={!isCodeRequest}
                                   onBlur={()=>validateById("code")}
                                   onChange={(e)=>{setValue("code",e.target.value); validateById("code")}}></input>
                            <div  className={["", styles.errMessage].join(' ')}>{getErrText("code")}</div>
                            <button type="button" className={["btn btn-secondary mt-1", styles.bthPost].join(' ')}
                                    disabled={!valCanRequest()}
                                    onClick={()=>handleRequestCode()}>
                                Получить код на почту</button>


                            <WaitLoader loading={ldrRequestCode} api={rsRequestCode} onlyLoading={true}>

                            </WaitLoader>
                        </div>



                        <div className={"d-flex justify-content-center mb-2"} style={{minHeight:"25px",textAlign:"center"}}>
                            <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>
                        </div>

                        <div className={"d-flex justify-content-center mt-2"}>
                            <button type="button" className="btn btn-secondary"
                                    onClick={(e)=>handlePassChange()}
                                    onKeyDown={(e)=>{
                                        if(e.key.match(/enter/i)){}
                                    }}
                                    disabled={!valCanChange()}

                            >Сменить</button>
                            <button type="button" className="btn btn-secondary" onClick={()=>{dispatch(setSlider({sliderMode:0}));navigate('/')}}>Отмена</button>

                        </div>



                    </form>
                </div>
            </div>
        </ModalWindow>
    )
}